import { generateJSON } from "@tiptap/core";

import { normalizeDocument } from "./normalize";
import { createEditorExtensions } from "./extensions";
import { serializeDocument, type ProseMirrorDocument } from "./serialize";

/**
 * HTML -> editor document -> Markdown (the import path).
 *
 * A Word import arrives as HTML (mammoth's output) and must land in a draft as
 * Markdown (AGENTS.md §11). Rather than a second HTML-to-Markdown converter,
 * the document goes through the same extension set the editor uses and the same
 * serializer every draft save uses — one mapping, defined once, so an imported
 * article reads exactly like one that was typed.
 *
 * The result is normalized (normalize.ts): escape residue in the source text
 * is dissolved and Word's underlined subheadings are stripped, so what lands
 * in the editor is what a reader would see.
 *
 * Browser-only: `generateJSON` builds a throwaway editor, so it needs a DOM.
 */
export function htmlToDocument(html: string): ProseMirrorDocument {
  // `generateJSON` returns TipTap's `JSONContent`; the serializer's narrower
  // read-only type is what the rest of the package speaks.
  return normalizeDocument(
    generateJSON(html, createEditorExtensions()) as unknown as ProseMirrorDocument,
  );
}

/** Parse an HTML string into Markdown through the editor's own pipeline. */
export function htmlToMarkdown(html: string): string {
  return serializeDocument(htmlToDocument(html));
}
